import { Component, h, Prop, Host, Element } from '@stencil/core';
import { checkSlottedContentForInvalidHTML } from '../../../global/utils/utils';
export class ParagraphComponent {
  constructor() {
    /**
     * Determines the over-ride size of the text
     */
    this.styledAs = 'md';
    /**
     * Determines the over-ride font
     */
    this.font = 'fontfamily02';
    /**
     * Determines the over-ride font colour
     */
    this.appearance = 'default';
    /**
     * Determines the over-ride bottom margin size
     */
    this.bottomMargin = null;
  }
  componentWillLoad() {
    checkSlottedContentForInvalidHTML(this.host, ['agl-ds-p', 'agl-ds-text', 'agl-ds-link', 'slot', 'agl-ds-tooltip', 'span']);
  }
  render() {
    if (!['display01', 'display02', 'inherit', 'lg', 'md', 'sm', 'xl', 'xs'].includes(this.styledAs)) {
      throw new Error(this.styledAs + ' is not a valid font size');
    }
    if (!['fontfamily01', 'fontfamily02'].includes(this.font)) {
      throw new Error(this.font + ' is not a valid font type');
    }
    if (this.appearance &&
      !['default', 'highlight', 'inverse', 'muted', 'secondary-highlight'].includes(this.appearance)) {
      throw new Error(this.appearance + ' is not a valid font colour');
    }
    return (h(Host, null,
      h("p", { class: {
          ['agl-ds-' + this.styledAs]: true,
          ['agl-ds-' + this.font]: true,
          ['agl-ds-' + this.appearance + '-colour']: true,
          ['agl-ds--bottom-margin-' + this.bottomMargin]: !!this.bottomMargin
        } },
        h("slot", null))));
  }
  static get is() { return "agl-ds-p"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() { return {
    "$": ["paragraph.component.scss"]
  }; }
  static get styleUrls() { return {
    "$": ["paragraph.component.css"]
  }; }
  static get properties() { return {
    "styledAs": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "FontSizes",
        "resolved": "\"display01\" | \"display02\" | \"inherit\" | \"lg\" | \"md\" | \"sm\" | \"xl\" | \"xs\"",
        "references": {
          "FontSizes": {
            "location": "import",
            "path": "../../../global/component.types"
          }
        }
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Determines the over-ride size of the text"
      },
      "attribute": "styled-as",
      "reflect": false,
      "defaultValue": "'md'"
    },
    "font": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "FontType",
        "resolved": "\"fontfamily01\" | \"fontfamily02\"",
        "references": {
          "FontType": {
            "location": "import",
            "path": "../../../global/component.types"
          }
        }
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Determines the over-ride font"
      },
      "attribute": "font",
      "reflect": false,
      "defaultValue": "'fontfamily02'"
    },
    "appearance": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "Appearance",
        "resolved": "\"default\" | \"highlight\" | \"inverse\" | \"muted\" | \"secondary-highlight\"",
        "references": {
          "Appearance": {
            "location": "import",
            "path": "../../../global/component.types"
          }
        }
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Determines the over-ride font colour"
      },
      "attribute": "appearance",
      "reflect": false,
      "defaultValue": "'default'"
    },
    "bottomMargin": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "BottomMargin",
        "resolved": "\"none\" | \"space00\" | \"space01\" | \"space02\" | \"space03\" | \"space04\" | \"space05\" | \"space06\"",
        "references": {
          "BottomMargin": {
            "location": "import",
            "path": "../../../global/component.types"
          }
        }
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Determines the over-ride bottom margin size"
      },
      "attribute": "bottom-margin",
      "reflect": false,
      "defaultValue": "null"
    }
  }; }
  static get elementRef() { return "host"; }
}
